module.exports = __webpack_public_path__ + "static/media/pinkpop.db5a48c9.jpg";